<template>
  <v-card-text>
    <div class="d-flex align-center">
      <h3>Список полей панели аттрибутов</h3>
      <v-btn class="ml-1" x-small icon @click="addMapping">
        <v-icon>add</v-icon>
      </v-btn>
    </div>
    <small>
      Данная функция предназначена для переименования
      и исключения полей из карточки геометрии.
      Если поля не добавлены, то отображаются оригинальные названия полей.
    </small>
    <div
      v-for="(mapping, idx) in settings.mappings"
      :key="idx"
      class="d-flex align-center"
    >
      <v-col md="3">
        <custom-select
          v-if="mappingAttributes.length"
          :list="mappingAttributes"
          :data="settings.mappings[idx].key"
          class="mr-2 flex-grow-1 flex-shrink-1"
          label="Исходное название поля"
          hide-details
          @change="(id) => settings.mappings[idx].key = id"
        />
        <v-text-field
          v-else
          v-model="settings.mappings[idx].key"
          class="mr-2"
          label="Исходное название поля"
          hide-details
        />
      </v-col>
      <v-col md="3">
        <v-text-field
          v-model="settings.mappings[idx].value"
          class="mr-2"
          label="Названия для отображение в карточке"
          hide-details
        />
      </v-col>
      <!-- Понадобится для использования в фильтрации-->
      <!-- <v-col md="3">
            <custom-select
              :list="mappingTypeList"
              :data="settings.mappings[idx].type"
              class="mr-2 flex-grow-1 flex-shrink-1"
              label="Тип поля"
              hide-details
              @change="(id) => settings.mappings[idx].type = id"
            />
          </v-col> -->

      <v-checkbox
        v-model="settings.mappings[idx].except"
        class="ml-2"
        label="Исключить"
        hide-details
      />
      <v-btn class="ml-2 mt-4" icon color="red" @click="removeMapping(idx)">
        <v-icon>delete</v-icon>
      </v-btn>
    </div>
    <div v-if="settings.mappings.length === 0">
      Не добавлено ни одного поля
    </div>
  </v-card-text>
</template>

<script>
import CustomSelect from '@/components/ui/custom-select';


const createDefaultMapping = () => ({
  key: '',
  value: '',
  type: '',
  except: false,
});

const mappingTypeList = [{
  id: 'number',
  name: 'Числовой',
},
{
  id: 'text',
  name: 'Текстовый',
}];

export default {
  name: 'mapping-attributes',

  components: {
    CustomSelect,
  },

  props: {
    settings: {
      type: Object,
      required: true,
    },

    layerAttributes: {
      type: Array,
      default: () => ([]),
    },
  },

  data() {
    return {
      mappingTypeList,
    };
  },

  computed: {
    mappingAttributes() {
      return this.layerAttributes.map((attr) => ({
        id: attr.slice(0, attr.indexOf(' ')),
        name: attr.slice(0, attr.indexOf(' ')),
      }));
    },
  },

  methods: {
    addMapping() {
      this.settings.mappings.push(createDefaultMapping());
      if (!this.layerAttributes.length) {
        this.$emit('get-layer-attributes');
      }
    },

    removeMapping(key) {
      this.settings.mappings.splice(key, 1);
    },
  },

};
</script>

<style lang="scss" scoped>

</style>
